import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-voip-service',
  templateUrl: './voip-service.component.html',
  styleUrls: ['./voip-service.component.scss']
})
export class VoipServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
